import { AfterViewInit, Component, HostListener, OnInit, Renderer2, ViewChild } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { OptionSelectorService } from "../../services/option-selector.service";
import { InspirationRoomOptionModel, InspirationRoomOptionStyle } from "../../../models/InspirationRoomOptionModel";
import { Observable } from "rxjs";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { map, startWith } from "rxjs/operators";
import { Globals } from "../../../services/globals";
import { NgxUiLoaderService } from 'ngx-ui-loader'
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { LocaleExceptionsModel } from "../../../models/LocaleExceptionsModel";
import { Option, StyleChoice } from "../../../engine/models/models";
import { LocaleExceptionsService } from "../../../services/localeExceptions.service";
import { MatDialog } from "@angular/material/dialog";
import { TranslatorComponent } from "../../../translator/translator.component";
import { InspirationRoomTipsModel } from "../../../models/InspirationRoomTipsModel";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'option-selector',
  templateUrl: 'option-selector.component.html',
  styleUrls: ['./option-selector.component.css'],
})

export class OptionSelectorComponent implements OnInit, AfterViewInit {
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  myControl = new UntypedFormControl();
  public tipForm: UntypedFormGroup;
  isAlreadyExists: boolean = false;
  showValidation: boolean = false;
  showTip: boolean = false;
  showToggle = true;
  languageControl = new UntypedFormControl();
  filteredOptions: Observable<Option[]>;
  filteredLanguage: Observable<string[]>;
  public option = new InspirationRoomOptionModel();
  public tip = new InspirationRoomTipsModel();

  name: string;
  languageId: number;
  subLabel: string;
  selectedOptionId: number;
  selectedOption: Option;
  selectedOptionDisplayName: string;
  headerText: string;
  currentOptionId = 0;
  currentTipId = 0;
  isOptionSelected = true;
  isTranslated = false;
  showTranslateIcon = false;
  selectedlanguageName: string;
  isDuplicate: boolean = false;
  public availableOptions: Option[];
  public localeExceptions: LocaleExceptionsModel = new LocaleExceptionsModel;
  public availableLanguageCodes: any[];

  constructor(private bottomSheetRef: MatBottomSheetRef<OptionSelectorComponent>,
    private service: OptionSelectorService,
    private localeExceptionsService: LocaleExceptionsService,
    private globals: Globals,
    private toastr: ToastrService,
    private loader: NgxUiLoaderService,
    private renderer: Renderer2,
    public dialog: MatDialog) {
    this.availableOptions = this.globals.globalOptions;
  }

  ngOnInit() {
    this.loadLanguageCodes();
    this.tipForm = new UntypedFormGroup({
      tipTitle: new UntypedFormControl('', [Validators.required]),
      tipDescription: new UntypedFormControl('', [Validators.required]),
    });
    this.tip = new InspirationRoomTipsModel();
    if (this.globals.currentTipId > 0) {
      this.tip = this.globals.selectedGlobalTip;
      this.currentTipId = this.globals.selectedGlobalTip.id;
      this.showToggle = false;
      this.showTip = true;
      this.headerText = 'Update';
    } else {
      this.headerText = 'Add';
    }
    if (this.globals.defaultTip) {
      this.showTip = true;
    }
  }

  public error = (controlName: string, errorName: string) => {
    return this.tipForm.controls[controlName].hasError(errorName);
  }

  loadData() {
    this.loadAllOptions();

    setTimeout(() => {
      this.filteredOptions = this.myControl.valueChanges
        .pipe(startWith(''), map(value => this._filter(value)));

      var elem = this.renderer.selectRootElement('#autocomplete');
      this.renderer.listen(elem, "focus", () => { });
      this.renderer.listen(elem, "blur", () => { });
      elem.focus();
      this.autocomplete.closePanel();
    }, 1000);

    setTimeout(() => {
      this.filteredLanguage = this.languageControl.valueChanges
        .pipe(startWith(''), map(value => this._filterLanguage(value)));
    }, 1000);
  }

  ngAfterViewInit() {
    this.currentOptionId = this.globals.currentOptionId;
    if (!this.showTip) {
      this.loadData();
    }
  }

  private _filter(value: string): Option[] {
    if (!value) return [];

    // Normalize the input value: trim, convert to lowercase, and remove extra spaces
    value = value.trim().toLowerCase().replace(/\s+/g, ' ');

    // Split the input value into words
    const searchWords = value.split(' ');

    // Prepare options by flattening availableOptions and their childOptions
    const subOptions = this.availableOptions.filter(q => q.childOptions?.length).flatMap(a => a.childOptions);
    const allOptions = this.availableOptions.concat(subOptions);

    // Filter options that contain all of the words in searchWords
    let matches = allOptions.filter(option => {
      // Combine description and displayName, if present, into a single search target
      const searchTarget = (option.description + (option.displayName ? " " + option.displayName : "")).toLowerCase();

      // Check if every search word is included in the search target
      return searchWords.every(word => searchTarget.includes(word));
    });

    // Further filter out already added options
    matches = matches.filter(x => !this.globals.addedOptions.map(o => o.optionId).includes(x.optionId));

    // Sort and limit the number of matches if necessary
    matches.sort((a, b) => (a.matchCount < b.matchCount) ? 1 : -1);

    //if (matches.length > 30) {
    //  return matches.slice(0, 30);
    //}

    return matches;
  }

  private _filterLanguage(value: string): string[] {
    // Check for null, undefined, or empty strings
    if (!value) return;

    const filterValue = value.toLowerCase();

    const filtered = this.availableLanguageCodes.filter(options => (
      (options.name && options.name?.toLowerCase().includes(filterValue))
    ));

    if (filtered.length < 10) return filtered;

    return filtered.slice(0, 10);
  }
  loadLanguageCodes() {
    this.localeExceptionsService.getLanguageCodes().subscribe(response => {
      this.availableLanguageCodes = response;
      if (this.globals.selectedCode !== null && this.globals.selectedCode !== undefined) {
        let selectedlanguage = this.availableLanguageCodes.find(x => x.languageCode == this.globals.selectedCode);
        if (selectedlanguage) {
          this.selectedlanguageName = selectedlanguage.name;
        }
      }
    });
  }

  optionChange(optionId: number) {
    this.resetStyleSelections();
    this.checkOptionExistence(optionId);

    this.stopLoading();
    this.setOptionSelectionState();

    this.selectedOptionId = optionId;
    const selectedOption = this.findOptionById(this.selectedOptionId);

    if (selectedOption) {
      this.setSelectedOption(selectedOption);
      this.setControlValue(selectedOption);
      this.addStyleSelections(selectedOption);
    }
  }

  resetStyleSelections() {
    this.option.styleSelections = [];
  }

  checkOptionExistence(optionId: number) {
    const option = this.globals.addedOptions.some(x => x.optionId === optionId);
    this.isAlreadyExists = optionId !== this.selectedOptionId && option;
  }

  stopLoading() {
    this.loader.stop();
  }

  setOptionSelectionState() {
    this.isOptionSelected = true;
    this.showTranslateIcon = true;
  }

  findOptionById(optionId: number) {
    const subOptions = this.availableOptions.filter(q => q.childOptions?.length).flatMap(a => a.childOptions);
    const allOptions = this.availableOptions.concat(subOptions);
    return allOptions.find(x => x.optionId === optionId);
  }

  setSelectedOption(option) {
    this.selectedOption = option;
    this.selectedOptionDisplayName = option.displayName || option.description;
  }

  setControlValue(option) {
    const optionDescription = `${option.description}${option.displayName ? ` (${option.displayName})` : ''}`;
    this.myControl.setValue(optionDescription);
  }

  addStyleSelections(option) {
    if (option.styleSelections && option.styleSelections.length) {
      for (let styleSelection of option.styleSelections) {
        let model: InspirationRoomOptionStyle = {
          id: 0,
          styleSelectionId: styleSelection.optionId,
          styleSelection: styleSelection.description,
          style: "",
          styleId: 0,
          optionId: option.optionId,
          inspirationRoomOptionId: 0,
          displayName: styleSelection.displayName,
          inActive: styleSelection.inActive
        };

        if (this.option && !this.option.styleSelections) {
          this.resetStyleSelections();
        }

        this.option.styleSelections.push(model);
      }
    }
  }

  loadAllOptions() {
    this.initializeControls();
    if (this.globals.currentOptionId > 0) {
      this.setControlValues();
      this.loadStyleSelections();
      this.isOptionSelected = true;
    }
    this.loader.stop();
  }

  initializeControls() {
    this.currentOptionId = 0;
    this.loader.stop();
    this.myControl.setValue("");
    this.showTranslateIcon = this.globals.currentOptionId > 0;
    this.currentOptionId = this.globals.currentOptionId;
  }

  setControlValues() {
    let myControlValue = null;
    if (this.globals.selectedGlobalOption) {
      let displayName = this.buildDisplayName();
      this.selectedOptionId = this.globals.selectedGlobalOption.optionId;
      this.selectedOption = this.globals.selectedGlobalOption;
      myControlValue = this.globals.selectedGlobalOption.description + displayName;
    } else {
      myControlValue = this.globals.selectedRoomOption.displayName;
    }
    this.myControl.setValue(myControlValue);
    this.subLabel = this.globals.subLabel;
  }

  buildDisplayName() {
    let displayName = this.globals.selectedGlobalOption.displayName;
    if (displayName !== "") {
      displayName = ` (${this.globals.selectedGlobalOption.displayName})`;
      this.selectedOptionDisplayName = this.globals.selectedGlobalOption.displayName;
    } else {
      this.selectedOptionDisplayName = this.globals.selectedGlobalOption.description;
    }
    return displayName;
  }

  loadStyleSelections() {
    if (this.selectedOption.styleSelections && this.selectedOption.styleSelections.length) {
      for (let styleSelection of this.selectedOption.styleSelections) {
        let model = this.buildStyleSelectionModel(styleSelection);
        this.initiateStyleSelections();
        this.option.styleSelections.push(model);
      }
    }
  }

  buildStyleSelectionModel(styleSelection) {
    let model = new InspirationRoomOptionStyle();
    if (this.globals.selectedRoomOptionStyles && this.globals.selectedRoomOptionStyles.some(x => x.styleSelectionId == styleSelection.optionId)) {
      let existingStyle = this.globals.selectedRoomOptionStyles.find(x => x.styleSelectionId == styleSelection.optionId);
      model = this.buildModelFromExistingStyle(existingStyle, styleSelection);
    } else {
      model = this.buildModelFromNewStyle(styleSelection);
    }
    return model;
  }

  buildModelFromExistingStyle(existingStyle, styleSelection) {
    return {
      id: existingStyle.id,
      styleSelectionId: existingStyle.styleSelectionId,
      styleSelection: existingStyle.styleSelection,
      style: styleSelection.styleChoices.some(x => x.optionId == existingStyle.styleId) ? existingStyle.style : '',
      styleId: styleSelection.styleChoices.some(x => x.optionId == existingStyle.styleId) ? existingStyle.styleId : 0,
      optionId: existingStyle.optionId,
      inspirationRoomOptionId: existingStyle.inspirationRoomOptionId,
      displayName: existingStyle.displayName,
      inActive: styleSelection.inActive
    };
  }

  buildModelFromNewStyle(styleSelection) {
    return {
      id: 0,
      styleSelectionId: styleSelection.optionId,
      styleSelection: styleSelection.description,
      style: '',
      styleId: 0,
      optionId: this.selectedOptionId,
      inspirationRoomOptionId: this.globals.selectedRoomOption.id,
      displayName: styleSelection.displayName,
      inActive: styleSelection.inActive
    };
  }

  initiateStyleSelections() {
    if (this.option && !this.option.styleSelections) {
      this.option.styleSelections = []
    }
  }

  styleSelections() {
    if (this.option.styleSelections && this.option.styleSelections.length) {
      for (let style of this.option.styleSelections) {
        if (style.styleId) {
          let selectedStyle = this.selectedOption.styleSelections.find(x => x.optionId == style.styleSelectionId)?.styleChoices.find(s => s.optionId == style.styleId);
          style.style = selectedStyle?.displayName ? selectedStyle.displayName : selectedStyle?.description;
        } else {
          style.style = null;
        }
      }
    }
  }

  addOption(): void {
    this.loader.stop();
    if (this.isAlreadyExists) {
      this.showValidation = true;
      return;
    }
    else {
      this.showValidation = false;
    }
    if (this.myControl.value === "" || this.myControl.value === undefined) {
      this.isAlreadyExists = false;
      this.selectedOptionId = 0;
    }
    if (!this.selectedOption) {
      this.isOptionSelected = false;
      document.getElementById("autocomplete").blur();
      return;
    }
    const result = this.globals.addedOptions.find(x => x.optionId == this.selectedOptionId);
    if (this.currentOptionId < 1 && result != null) {
      this.showValidation = true;
      return;
    }
    this.option.id = this.globals.currentOptionId;

    let optionDetail = this.availableOptions.find(x => x.optionId === this.selectedOptionId);

    if (!optionDetail) {
      optionDetail = this.availableOptions.filter(q => q.childOptions?.length).flatMap(a => a.childOptions).find(x => x.optionId === this.selectedOptionId);
    }

    this.styleSelections();

    this.option.displayName = optionDetail.displayName ? optionDetail.displayName : optionDetail.description;
    this.option.subLabel = this.subLabel;
    this.option.globalOptions = optionDetail;
    this.option.optionId = optionDetail.optionId;
    this.option.description = optionDetail.description;
    this.service.loadOption(this.option);
    this.bottomSheetRef.dismiss();
    event.preventDefault();
    this.closeBottomSheet();
  }

  addTip(): void {
    if (!this.tipForm.valid) {
      this.showValidation = true;
      return;
    }
    //const result = this.globals.addedOptions.find(x => x.optionId == this.selectedOption);
    //if (this.currentOptionId < 1 && result != null) {
    //  this.showValidation = true;
    //  return;
    //}
    this.tip.id = this.globals.currentTipId;
    this.service.loadTip(this.tip);
    this.bottomSheetRef.dismiss();
    event.preventDefault();
    this.closeBottomSheet();
  }
  deleteOption() {
    this.service.deleteOptions(this.currentOptionId).subscribe(response => {
      this.service.loadOption(null);
      this.bottomSheetRef.dismiss();
      event.preventDefault();
    });
  }
  deleteTip() {
    this.service.deleteTip(this.currentTipId).subscribe(response => {
      this.service.loadOption(null);
      this.bottomSheetRef.dismiss();
      event.preventDefault();
    });
  }
  closeBottomSheet() {
    this.loader.stop();
    this.bottomSheetRef.dismiss();
  }

  openTranslateDialog() {
    const translateDialog = this.dialog.open(TranslatorComponent, {
      minWidth: '60%',
      data: { displayName: this.selectedOptionDisplayName, selectedOption: this.selectedOption }
    });

    translateDialog.afterClosed().subscribe(result => {
      return;
    });
  }

  get hasStyle() {
    return this.selectedOption && this.selectedOption.styleSelections && this.selectedOption.styleSelections.length;
  }

  autofillStyle() {
    this.styleSelections();
    if (!this.option.styleSelections.some(x => x.styleId > 0)) {
      this.toastr.warning("Please select a style first.")
      return;
    }
    let selectedStyles = [];
    for (let style of this.option.styleSelections.filter(x => x.styleId > 0 && x.style)) {
      selectedStyles.push(style.style)
    }
    this.subLabel = selectedStyles.join('; ');
  }

  get isInactive(): boolean {
    return (this.currentOptionId > 0 && !this.globals.selectedGlobalOption);
  }
  get tooltip(): string {
    return this.isInactive ? 'This option is inactive, you can delete it' : '';
  }
}
